import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Run the following command to install the package:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @capawesome/capacitor-posthog posthog-js
`}</code></pre>
    <p>{`After installing the package, you need to update your Capacitor project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npx cap update
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <p>{`To use the plugin, you need to call the `}<inlineCode parentName="p">{`setup(...)`}</inlineCode>{` method with your PostHog project API key and host which you can find in `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project"
      }}>{`your project settings`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Posthog } from '@capawesome/capacitor-posthog';

const setup = async () => {
  await Posthog.setup({
    apiKey: '<ph_project_api_key>',
    host: '<ph_client_api_host>',
  });
};
`}</code></pre>
    <p>{`You pass in a `}<inlineCode parentName="p">{`host`}</inlineCode>{` key to specify the PostHog instance you want to send events to. The default host is `}<inlineCode parentName="p">{`https://us.i.posthog.com`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      